import { BookingSummarySkeleton, FlightDetailsSkeleton, PassengersSkeleton, SkeletonBlock } from "./TravelTransactionDetailsSkeleton.shared";

export default function TravelTransactionDetailsSkeletonMob() {
  return (
    <div className="flex w-full flex-col gap-4 pb-5">
      <BookingSummarySkeleton />
      <FlightDetailsSkeleton />
      <PassengersSkeleton />
      <div className="shadow-bottom-sheet bg-background-default fixed start-0 end-0 bottom-0 z-50 rounded-t-xl p-4">
        <SkeletonBlock className="h-10 w-full" />
      </div>
    </div>
  );
}
